import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExoticDiamond = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 17.31 17.508",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		"data-name": "Icon - Exotic",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M16.81 7.081H.5",
				"data-name": "Line 1205"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.655 17.009.5 7.081 4.046.699h9.219l3.545 6.382Z",
				"data-name": "Path 5666"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "m4.046.698 4.609 6.383",
				"data-name": "Line 1206"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M13.264.698 8.655 7.081",
				"data-name": "Line 1207"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.655 7.081v9.928",
				"data-name": "Line 1208"
			})
		]
	})
});
export { SvgExoticDiamond as ReactComponent };
